import { createI18n } from "vue-i18n";
import fr from "../lang/fr";
import en from "../lang/en";

let locale = "en";
const langSupported = ["fr", "en"];
const langGlobal = navigator.language.split("-")[0];

if (langSupported.indexOf(langGlobal) >= 0) {
    locale = langGlobal;
}

let messages = {};
if (APP_ENV !== "testing") {
    messages = { fr, en };
}

const i18n = createI18n({
    legacy: true,
    globalInjection: true,
    fallbackLocale: "fr",
    locale,
    messages,
});

export const installTranslationHelpers = (app) => {
    const globals = app.config.globalProperties;

    globals.$getTranslationKey = function (key, restaurantId = undefined, locale = undefined) {
        let lexicon = THEME === "noshow" ? "restaurant" : "generic";

        const noRestaurantId = [undefined, null, 0, ""];

        if (noRestaurantId.includes(restaurantId)) {
            restaurantId = this.$route.params.restaurant_id;
        }

        if (!noRestaurantId.includes(restaurantId)) {
            lexicon = this.$store.getters["restaurants/lexicon"](restaurantId);
        }

        const tmpKey = `lexicons.${lexicon}.${key}`;

        return i18n.global.te(tmpKey, locale) ? tmpKey : key;
    };

    globals.$tl = function (key, restaurantId = undefined, values = undefined, locale = undefined) {
        return this.$t(this.$getTranslationKey(key, restaurantId, locale), values);
    };

    globals.$tcl = function (key, count, restaurantId = undefined, values = undefined, locale = undefined) {
        return this.$tc(this.$getTranslationKey(key, restaurantId, locale), count, values);
    };
};

export default i18n;
